import { useEffect, useState } from "react";
import InputText1 from "../components/InputText1";
import Button2 from "../components/Button2";
import AlertModal from "../components/AlertModal";
import { adminServices } from "../services/AdminServices";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import Dropdown from "../components/Dropdown";
const KioskPageAdd = () => {
  const [deviceId, setDeviceID] = useState('');
  const [serialNumber, setSerialNumber] = useState('');
  const [kioskName, setKioskName] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [kioskPin, setKioskPin] = useState('');
  const [quadrants, setQuadrants] = useState(["N/A"]);
  const [colony, setColony] = useState(null);
  const [colonies, setColonies] = useState([]);
  const [facilities, setFacilities] = useState([]);
  useEffect(() => {
    getColonies();
  }, []);
  useEffect(() => {
    if (colony) {
      const fac = colonies.find(c => c.value == colony)?.fac;
      var defaultOption = {};
      setFacilities(fac || []);
      // Colony changed: keep Not Applicable as default.
      setQuadrants(["N/A"]);
      return;
    }

    // No colony selected: keep Not Applicable as default.
    setFacilities([]);
    setQuadrants(["N/A"]);
  }, [colony, colonies]);
  const getColonies = () => {
    adminServices.storeProcedure2('getColonies', {}).then(r => {
      // expecting columns: colony_id, colony_name
      const data = r.data || [];
      const opts = data.map(c => ({
        value: c.colony_id,
        label: c.colony_name,
        fac: JSON.parse(c.facilities || [])
      }));
      var defaultOption = {
        label: '--- Select Kiosk Location ---',
        value: null
      };
      setColonies([defaultOption, ...opts]);
    }).catch(e => {
      //console.log('getColonies error', e);
    });
  };
  const handleCheckboxChange = value => {
    setQuadrants(prev => {
      if (value == null || value === "") return prev;
      if (prev.includes(value)) {
        return prev.filter(item => item !== value);
      }
      return [...prev, value];
    });
  };
  return <div style={{
    width: '80%'
  }}>
         <h2>Add Kiosk Terminal</h2>
         <AlertModal title={"Add Kiosk Terminal"} show={showAlert} message={alertMessage} onClose={() => {
      setShowAlert(false);
    }}></AlertModal>
        <form className="padalaForm">
        <InputText1 title={"Kiosk Device ID*"} value={deviceId} placeholder={"App Device ID"} onChange={e => {
        setDeviceID(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Serial Number ID*"} value={serialNumber} placeholder={"Serial Number"} onChange={e => {
        setSerialNumber(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Kiosk Name*"} value={kioskName} placeholder={"Kiosk Name"} onChange={e => {
        setKioskName(e.target.value);
      }} maxLength={50} />

        <InputText1 title={"Kiosk Password*"} value={kioskPin} type="password" placeholder={"Assign a Kiosk Password"} onChange={e => {
        setKioskPin(e.target.value);
      }} maxLength={50} />

         <Dropdown title={"Store Location"} data={colonies} value={colony} onChange={e => {
        const val = e.target.value;
        setColony(val);
      }} />
        </form>

        <div className="mt-3 mb-3">
            <div className="mb-2 fw-semibold">Facilities / Quadrants</div>
            <div className="row row-cols-1 row-cols-md-3 g-2">
                <div className="col">
                    <div className="form-check border rounded px-3 py-2 h-100">
                        <input id="kiosk-facility-na" className="form-check-input" type="checkbox" checked={quadrants.includes("N/A")} onChange={() => handleCheckboxChange("N/A")} />
                        <label className="form-check-label" htmlFor="kiosk-facility-na">
                            Not Applicable
                        </label>
                    </div>
                </div>

                {facilities.map((facility, idx) => {
          const key = facility?.FacilityId ?? facility?.Facility ?? idx;
          const id = `kiosk-facility-${String(facility?.FacilityId ?? idx)}`;
          return <div className="col" key={key}>
                            <div className="form-check border rounded px-3 py-2 h-100">
                                <input id={id} className="form-check-input" type="checkbox" checked={quadrants.includes(facility?.FacilityId)} onChange={() => handleCheckboxChange(facility?.FacilityId)} />
                                <label className="form-check-label" htmlFor={id}>
                                    {String(facility?.Facility ?? "")}
                                </label>
                            </div>
                        </div>;
        })}
            </div>
        </div>

        <Button2 text={"Submit"} onClick={async () => {
      if (deviceId === '') {
        setAlertMessage('Kiosk Device ID Required');
        setShowAlert(true);
        return;
      }
      if (serialNumber === '') {
        setAlertMessage('Serial Number Required');
        setShowAlert(true);
        return;
      }
      if (kioskName === '') {
        setAlertMessage('Kiosk Name Required');
        setShowAlert(true);
        return;
      }
      var form = {
        "appDeviceId": deviceId,
        "serialNumber": serialNumber,
        "kioskName": kioskName,
        "devicePin": kioskPin,
        "quadrants": quadrants.join('|'),
        "colony": colony
      };
      await adminServices.addKiosk(form).then(r => {
        if (r.status == 201 || r.status == 204 || r.status == 200) {
          window.location.href = "/kiosk-status-reports";
        }
      }).catch(e => {
        if (e.status == 401) {
          window.location.href = "/";
        }
        if (e.status == 500) {
          setAlertMessage("An error occured, please check for duplicate entries");
          setShowAlert(true);
        }
      });
    }} style={{
      width: "200px",
      backgroundColor: "#61dd48"
    }} />
    </div>;
};
export default withAuthorization(KioskPageAdd, 20);